/**
 * Lazy/safe wrapper around @rsos/utils/sentry.
 *
 * Sinatra is consumed across apps/tests that can partially mock @rsos/utils
 * and @rsos/utils/metaTags. Avoid importing sentry at module-load time to
 * prevent import-time crashes from those partial mocks.
 */
export const captureExceptionSafe = (...args) => {
  try {
    const sentry = require('@rsos/utils/sentry');
    if (typeof sentry?.captureException === 'function') {
      sentry.captureException(...args);
    }
  } catch (error) {
    // Intentionally swallow telemetry issues to avoid breaking auth flows/tests.
  }
};
